import {
  JIRA_SETTING_REQUEST,
  JIRA_SETTING_SUCCESS,
  JIRA_SETTING_ERROR,
  JIRA_SETTING_SET,
  JIRA_SETTING_CREATE_REQUEST,
  JIRA_SETTING_DELETE_REQUEST,
  JIRA_SETTING_DELETE_SUCCESS,
  JIRA_SETTING_DELETE_ERROR,
  JIRA_CREATE_TICKET,
  PROJECT_ID_SET,
  JIRA_TICKET_FETCH_DETAILS,
  JIRA_TICKET_DETAILS_SET,
  JIRA_TICKET_STATUS_CHANGE,
  JIRA_FETCH_TICKETS,
  JIRA_FETCH_TICKETS_VALUES_SET,
  JIRA_ALL_TICKETS,
  JIRA_ALL_TICKETS_SET,
  JIRA_CONFIGURATION_REQUEST,
  JIRA_CONFIGURATION_SUCCESS,
  JIRA_CONFIGURATION_ERROR,
  JIRA_CONFIGURATION_SET,
  JIRA_SETTING_UPDATE_REQUEST,
  JIRA_SETTING_UPDATE_SUCCESS,
  JIRA_SETTING_UPDATE_ERROR
} from './jira-setting.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import { jiraConfigMetaInfo } from '@/column-header/jira/jira-config-meta'
import { OrderByEnum } from '@/constants/orderby.constants'


const state = {
  jiraSettingReqStatus: state => state.jiraSettingReqStatus,
  jiraSettings: {},
  jiraTicketDetails: {},
  fetchTickets: [],
  jiraAllTickets: [],
  jiraConfigs: {}
}

const getters = {
  jiraSettings: state => state.jiraSettings,
  projectIds: state => state.projectIds,
  jiraTicketDetails: state => state.jiraTicketDetails,
  fetchTickets: state => state.fetchTickets,
  jiraAllTickets: state => state.jiraAllTickets,
  jiraConfigs: state => state.jiraConfigs
}

const mutations = {
  [JIRA_SETTING_REQUEST]: state => (state.jiraSettingReqStatus = 'loading'),
  [JIRA_SETTING_SUCCESS]: state => (state.jiraSettingReqStatus = 'success'),
  [JIRA_SETTING_ERROR]: state => (state.jiraSettingReqStatus = 'error'),
  [JIRA_SETTING_SET]: (state, settings) => {
    state.jiraSettings = settings
  },
  [JIRA_SETTING_DELETE_REQUEST]: state => (state.jiraSettingDeleteReqStatus = 'loading'),
  [JIRA_SETTING_DELETE_SUCCESS]: state => (state.jiraSettingDeleteReqStatus = 'success'),
  [JIRA_SETTING_DELETE_ERROR]: state => (state.jiraSettingDeleteReqStatus = 'error'),
  [JIRA_CONFIGURATION_REQUEST]: state => (state.jiraConfigurationReqStatus = 'loading'),
  [JIRA_CONFIGURATION_SUCCESS]: state => (state.jiraConfigurationReqStatus = 'success'),
  [JIRA_CONFIGURATION_ERROR]: state => (state.jiraConfigurationReqStatus = 'error'),
  [JIRA_CONFIGURATION_SET]: (state, data) => {
    state.jiraConfigs = data
  },
  [JIRA_SETTING_UPDATE_REQUEST]: state => (state.jiraSettingUpdateReqStatus = 'loading'),
  [JIRA_SETTING_UPDATE_SUCCESS]: state => (state.jiraSettingUpdateReqStatus = 'success'),
  [JIRA_SETTING_UPDATE_ERROR]: state => (state.jiraSettingUpdateReqStatus = 'error'),
  [PROJECT_ID_SET]: (state, data) => {
    state.projectIds = data
  },
  [JIRA_TICKET_DETAILS_SET]: (state, data) => (state.jiraTicketDetails = data),
  [JIRA_FETCH_TICKETS_VALUES_SET]: (state, data) => {
    state.fetchTickets = data
  },
  [JIRA_ALL_TICKETS_SET]: (state, data) => {
    state.jiraAllTickets = data
  }
}

const actions = {
  // Saving and Fetching Jira Credentials.
  [JIRA_SETTING_REQUEST](context) {
    context.commit(JIRA_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('setting/jira')
        .then(({ data }) => {
          context.commit(JIRA_SETTING_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },
  [JIRA_SETTING_SUCCESS]: ({ commit }) => {
    commit(JIRA_SETTING_SUCCESS)
  },
  [JIRA_SETTING_CREATE_REQUEST](context, payload) {
    context.commit(JIRA_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('setting/jira', {
          emailId: payload.emailId,
          apiToken: payload.apiToken,
          workspaceUrl: payload.workspaceUrl,
          projectId: payload.projectId
        })
        .then(resp => {
          context.commit(JIRA_SETTING_SET, resp)
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },

  // For Jira Configuration screen
  [JIRA_CONFIGURATION_REQUEST](context) {
    context.commit(JIRA_CONFIGURATION_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('configurations/jira')
        .then(({ data }) => {
          data = new IQCollection(
            data,
            { attributes: jiraConfigMetaInfo.meta.columns },
            { defaultSort: 'workspace_url', sortOrder: OrderByEnum.DESC }
          )
          context.commit(JIRA_CONFIGURATION_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_CONFIGURATION_ERROR)
          reject(errMsg)
        })
    })
  },
  [JIRA_SETTING_DELETE_REQUEST](context, { projectID } = '') {
    context.commit(JIRA_SETTING_DELETE_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`configurations/jira/${projectID}`, {
          project_id: projectID
        })
        .then(resp => {
          context.commit(JIRA_SETTING_DELETE_SUCCESS)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_DELETE_ERROR)
          reject(errMsg)
        })
    })
  },
  [JIRA_SETTING_UPDATE_REQUEST](context, payload) {
    context.commit(JIRA_SETTING_UPDATE_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .put(`configurations/jira/${payload.id}`, {
          emailId: payload.emailId,
          apiToken: payload.apiToken,
          workspaceUrl: payload.workspaceUrl,
          projectId: payload.projectId
        })
        .then(resp => {
          context.commit(JIRA_SETTING_UPDATE_SUCCESS)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_UPDATE_ERROR)
          reject(errMsg)
        })
    })
  },

  //Jira Ticket creation
  [JIRA_CREATE_TICKET](context, payload) {
    context.commit(JIRA_SETTING_REQUEST)
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('ticket_creation', payload)
        .then(data => {
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },
  [JIRA_TICKET_FETCH_DETAILS](context, { selectedTrail } = '') {
    let url = `/ticket_creation/${selectedTrail}`
    return new Promise((resolve, reject) => {
      ApiRest()
        .get(url)
        .then(({ data }) => {
          context.commit(JIRA_TICKET_DETAILS_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },

  //Changing Ticket status as per actions
  [JIRA_TICKET_STATUS_CHANGE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('/jira_ticket_status', payload)
        .then(data => {
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },
  [JIRA_FETCH_TICKETS](context) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('jira_ticket_status')
        .then(({ data }) => {
          context.commit(JIRA_FETCH_TICKETS_VALUES_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  },

  //Fecthing all tickets including thier fields
  [JIRA_ALL_TICKETS](context) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('/all_jira_ticket')
        .then(({ data }) => {
          context.commit(JIRA_ALL_TICKETS_SET, data)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(JIRA_SETTING_ERROR)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/jira/jira-setting.module.js